function setHexWithAlphaToSolid(hexColor) {
    // Remove the "#" if it exists
    hexColor = hexColor.replace("#", "");

    // If it's a 3-character hex, expand to 6 characters
    if (hexColor.length === 4) {
        hexColor = hexColor.split("").map(x => x + x).join("");
    }

    // Convert hex to RGB
    const r = parseInt(hexColor.substring(0, 2), 16);
    const g = parseInt(hexColor.substring(2, 4), 16);
    const b = parseInt(hexColor.substring(4, 6), 16);

    // Calculate luminance (lighter colors will have higher luminance)
    const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

    // If the color is light (luminance > 128), return it as is (no alpha blending)
    if (luminance > 128) {
        return `#${hexColor}`; // Return the original hex color without modification
    }

    // If it's a 4-character hex (with alpha), expand it
    if (hexColor.length === 8) {
        const a = parseInt(hexColor.substring(6, 8), 16) / 255; // Convert alpha to a 0-1 range

        // Blend with white (255, 255, 255) based on alpha
        const solidR = Math.round(r * a + (1 - a) * 255);
        const solidG = Math.round(g * a + (1 - a) * 255);
        const solidB = Math.round(b * a + (1 - a) * 255);

        // Return the solid color as hex
        return `#${solidR.toString(16).padStart(2, '0')}${solidG.toString(16).padStart(2, '0')}${solidB.toString(16).padStart(2, '0')}`;
    }

    // If it's just a solid 6-character hex, return it as is
    return `#${hexColor}`;
}


export default setHexWithAlphaToSolid;